import { Chip, Typography } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import { useTranslate } from "react-admin";
const StatusField = ({
	source,
	record,
	basePath,
	sortable,
	sortBy,
	...props
}) => {
	const translate = useTranslate();
	const isApproved = get(record, "is_approved");
	const isTotal = get(record, "is_total");
	if (isTotal) {
		return null;
	}
	if (!isApproved) {
		return (
			<Typography variant="body2" {...props}>
				{translate("resources.user_payment_statuses.code.pending-approval")}
			</Typography>
		);
	}
	const label = translate(
		`resources.user_payment_statuses.code.${get(record, "status.code")}`
	);
	return <Chip label={label} {...props} />;
};
export default StatusField;
